import {Nullable, PartnersManagementListing} from 'common/types';
import {
  FETCH_PARTNERS_MANAGEMENT_LISTING_FAILURE,
  FETCH_PARTNERS_MANAGEMENT_LISTING_REQUEST,
  FETCH_PARTNERS_MANAGEMENT_LISTING_SUCCESS,
  PartnersAction,
} from '../types';

interface State {
  data: Nullable<PartnersManagementListing>;
  isFetching: boolean;
  error: Nullable<Error>;
}

const initialState: State = {
  data: null,
  isFetching: false,
  error: null,
};

export const managementReducer = (
  state: State = initialState,
  action: PartnersAction
) => {
  switch (action.type) {
    case FETCH_PARTNERS_MANAGEMENT_LISTING_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case FETCH_PARTNERS_MANAGEMENT_LISTING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    case FETCH_PARTNERS_MANAGEMENT_LISTING_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
};
